import "@/App.css";
import { ReactLenis } from "lenis/react";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Manifesto from "./components/Manifesto";
import Services from "./components/Services";
import PaperTossGame from "./components/PaperTossGame";
import SelectedWork from "./components/SelectedWork";
import Contact from "./components/Contact";
import CursorStar from "./components/CursorStar";
import ScrollProgress from "./components/ScrollProgress";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true, wheelMultiplier: 1 }}>
      <div className="App" data-testid="studio-franco-app">
        <CursorStar />
        <ScrollProgress />
        <Nav />
        <main>
          <Hero />
          <Manifesto />
          <Services />
          <PaperTossGame />
          <SelectedWork />
          <Contact />
        </main>
      </div>
    </ReactLenis>
  );
}

export default App;
